import React, { useState } from 'react';
import { Tr, Td, VisuallyHidden } from '@chakra-ui/react';
import ContactsActionMenu from '../ContactsActionMenu/ContactsActionMenu';
import { optionalValue } from '../../../services/text/optionalValue';
import { RenderIf } from '../RenderIf/RenderIf';
import { useTokens } from '../../../context/TokenProvider';
import { makeMed4 } from '../../../styles/textStyles';
import WrappableTableCell from '../Table/WrappableTableCell';
import { localise } from '../../../services/lang/lang';
const ContactsTableRow = ({ contact, onContactMutated, canEditContacts, inspection, isSelected, onContactDeleted, onRowClick, variant = 'page', isInteractive, onEditContactClicked, }) => {
    const tokens = useTokens();
    const srLabelText = `${contact.full_name ?? localise('CONTACT')} ${contact.email ?? ''}`;
    const [srSelectedRowMessage, setSrSelectedRowMessage] = useState('');
    const rowStyle = {
        ...(isSelected &&
            makeMed4(tokens, {
                color: tokens.TextDark800,
            })),
        td: {
            cursor: onRowClick ? 'pointer' : 'default',
        },
        backgroundColor: isSelected
            ? tokens.CanvasPrimary100
            : tokens.CanvasTableRowLight,
        _hover: isInteractive && !isSelected ? { backgroundColor: tokens.Layer02 } : {},
        _focus: {
            boxShadow: 'none',
        },
        _focusVisible: {
            borderTopWidth: tokens.Spacing01,
            borderTopColor: tokens.BorderFocus,
            borderBottomWidth: tokens.Spacing01,
            borderBottomColor: tokens.BorderFocus,
            boxShadow: 'none',
        },
    };
    const NameComponent = variant === 'modal' ? WrappableTableCell : Td;
    return (React.createElement(React.Fragment, null,
        React.createElement(VisuallyHidden, { "aria-live": "polite", "aria-atomic": "true" }, srSelectedRowMessage),
        React.createElement(Tr, { sx: rowStyle, "data-testid": "contacts_table_row_row", onClick: () => onRowClick?.(contact), onKeyDown: (e) => {
                if ((e.key === 'Enter' || e.key === ' ') &&
                    e.currentTarget === e.target) {
                    e.preventDefault();
                    e.stopPropagation();
                    onRowClick?.(contact);
                    const newSelectedState = !isSelected;
                    setSrSelectedRowMessage(newSelectedState
                        ? localise('ROW_SELECTED')
                        : localise('ROW_UNSELECTED'));
                }
            }, tabIndex: 0, "aria-label": srLabelText },
            React.createElement(Td, { minW: "56px", maxW: "56px", "data-testid": "contacts_table__action_menu", onClick: (e) => e.stopPropagation() },
                React.createElement(ContactsActionMenu, { inspection: inspection, onContactMutated: onContactMutated, contact: contact, canEditContacts: canEditContacts, onContactDeleted: onContactDeleted, onEditContactClicked: onEditContactClicked })),
            React.createElement(NameComponent, { "data-testid": "contacts_table_row__full_name" }, optionalValue(contact.full_name)),
            React.createElement(RenderIf, { condition: variant === 'modal' },
                React.createElement(Td, { "data-testid": "contacts_table_row__email" }, optionalValue(contact.email))),
            React.createElement(Td, { "data-testid": "contacts_table_row__type" }, contact._formatted.type_singleLine))));
};
export default ContactsTableRow;
